
/* eslint-disable */
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Alert from 'vux/src/components/alert/index.vue'

import { mapState, mapActions, mapMutations } from "vuex";
import { common, commonApi } from "@/common/index";
import login from "../login/index.vue";
import HeaderBase from "../components/header/base.vue";
import appDownloadDialog from "../components/app-download-dialog/index.vue";
import FloatDownload from "../../components/FloatDownload.vue";

import { tabbarOptions } from "../../libs/options.js";
import Texas from "../texas";

export default {
name: "App",
components: {
HeaderBase,
appDownloadDialog,
Tabbar,
TabbarItem,
Loading,
Popup,
login,
Alert,
Texas,
FloatDownload,
},
provide() {
return {
parentCom: this,
};
},
data() {
return {
loading: true,
timer: "",


appUUID: "", //从app处获取UUID
tabbarOptions: tabbarOptions,
showTelegramPopup: false,
bandingCode: "",
};
},
directives: {
TransferDom,
},
computed: {
...mapState({
isLoading: (state) => state.vux.isLoading,
bottomHeight: (state) => state.bottomHeight + "px",
isLogin: (state) => state.isLogin,
customer_service_system_link: (state) =>
state.FrontConfigList.customer_service_system_link,
showLogin: (state) => state.showLogin,
upholdShow: (state) => state.upholdShow, //是否维护弹窗
upholdInfo: (state) => state.upholdInfo, //维护弹窗信息
isApp: (state) => state.isApp, //是否在app打开
userInfo: (state) => state.userInfo.userInfo,
}),





},
watch: {
isLogin() {
if (this.isLogin) {
this.getFirstInfo();
this.getInEmail();
commonApi.HOMEAFTER.refreshUserInfo();

this.timer = setInterval(() => {
commonApi.HOMEAFTER.refreshUserInfo();
}, 1000 * 60 * 5);
} else {
this.$router.push({
path: "/home",
});
clearInterval(this.timer);
this.timer = "";
}
},
$route: {
handler(val) {
if (val.query.jumplogin == "true") {
this.SET_JUMPLOGIN_SHOW();
}
},
immediate: true,
},
appUUID(val) {
this.$Cookies.set("UUID", val);
this.LOGIN(val);
common.logedUserInfo();
this.getFirstInfo();
},
userInfo(n) {
if (!this.isLogin || n.id) {
this.loading = false;
}
},
},
methods: {
...mapActions([
"newinitLinkList",
"checkLogin",
"getFirstInfo",
"getDownloadUrl",
"getJinService",
"getInEmail",
"getBonusInfo",
"addJackPotMoney",
]),
...mapMutations([
"SET_NAV_LIST",
"SET_SLOT_PICLINK",
"SET_SLOT_PLATFORM",
"SET_LOGIN_SHOW",
"SET_JUMPLOGIN_SHOW",
"setupholdShow",
"setupholdInfo",
"LOGIN",
"setIsApp",
"SET_REGISTER",
]),
handleTab({ langKey, path }, index) {
if (this.isApp) {
if (langKey === "Home") common.emitAppMethods("JS_APP_HOME");
if (langKey === "Deposit") common.emitAppMethods("JS_APP_WealthCenter"); 
if (langKey === "Discounts")
common.emitAppMethods("JS_APP_ActivityList"); 
} else {
this.$router.push({ path });
}
},
showLog() {
if (this.isApp) {
common.emitAppMethods("JS_APP_Login");
} else {
this.SET_LOGIN_SHOW();
}
},
closealert() {
this.setupholdShow(false);
},
closeSide(val) {
this.drawerVisibility = val;
},
login(UUID) {
this.appUUID = UUID;
},
goRegister(v) {
if (this.isApp) {
common.emitAppMethods("JS_APP_Registered");
} else {
if (v === 1) {
this.$router.push({ path: "/register" });
} else {
this.SET_REGISTER(true);
}
}
},

appGoBack() {
common.emitAppMethods("JS_APP_GoBack");
},
checkThirdPartyLogin() {
const loadingToast = this.$toast.loading({
duration: 0,
forbidClick: true,
});
this.$Cookies.set("UUID", "");
commonApi.USER.telegramAuthLogin({
telegramCredential: window.telegram_credential,
})
.then((res) => {
const { bandingCode, newAccount, uuid } = res.data;
loadingToast.clear();
this.bandingCode = bandingCode;
if (newAccount) {
this.showTelegramPopup = true;
} else {
this.$Cookies.set("UUID", uuid);
common.logedUserInfo();
this.checkLogin();
}
})
.catch((err) => {
this.$toast({
message: err.message || err.msg,
icon: "warning",
});
});
},
telegramDialogRegister() {
const loadingToast = this.$toast.loading({
duration: 0,
forbidClick: true,
});
this.$api.post(
this.$urls.USER.bindingAccount,
{
hasBinding: false,
bindingCode: this.bandingCode,
},
(res) => {
loadingToast.clear();
this.showTelegramPopup = false;
if (res.data.code === 200) {
let { uuid, loginSuccess } = res.data.data;

if (loginSuccess && uuid) {
this.$Cookies.set("UUID", uuid);
common.logedUserInfo();
this.checkLogin(); 
}
} else {
this.$toast({
message: res.data.msg,
icon: "warning",
});
}
},
(err) => {
window.location.reload();
}
);
},
telegramDialogLogin() {
sessionStorage.setItem("bandingCode", this.bandingCode);
this.showTelegramPopup = false;
this.SET_LOGIN_SHOW();
},
},
async created() {
if (window.telegram_credential) {
await this.checkThirdPartyLogin();
}

await this.checkLogin();
},
async mounted() {
this.newinitLinkList();


this.getJinService();
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/main/index.vue